/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CheckinInstructions } from './CheckinInstructions';
import {
    CheckinInstructionsFromJSON,
    CheckinInstructionsFromJSONTyped,
    CheckinInstructionsToJSON,
    CheckinInstructionsToJSONTyped,
} from './CheckinInstructions';
import type { Policy } from './Policy';
import {
    PolicyFromJSON,
    PolicyFromJSONTyped,
    PolicyToJSON,
    PolicyToJSONTyped,
} from './Policy';
import type { CheckoutInstructions } from './CheckoutInstructions';
import {
    CheckoutInstructionsFromJSON,
    CheckoutInstructionsFromJSONTyped,
    CheckoutInstructionsToJSON,
    CheckoutInstructionsToJSONTyped,
} from './CheckoutInstructions';
import type { HotelPropertyContentRoom } from './HotelPropertyContentRoom';
import {
    HotelPropertyContentRoomFromJSON,
    HotelPropertyContentRoomFromJSONTyped,
    HotelPropertyContentRoomToJSON,
    HotelPropertyContentRoomToJSONTyped,
} from './HotelPropertyContentRoom';
import type { HotelCuratedContent } from './HotelCuratedContent';
import {
    HotelCuratedContentFromJSON,
    HotelCuratedContentFromJSONTyped,
    HotelCuratedContentToJSON,
    HotelCuratedContentToJSONTyped,
} from './HotelCuratedContent';
import type { PropertyFee } from './PropertyFee';
import {
    PropertyFeeFromJSON,
    PropertyFeeFromJSONTyped,
    PropertyFeeToJSON,
    PropertyFeeToJSONTyped,
} from './PropertyFee';
import type { RatingForCategory } from './RatingForCategory';
import {
    RatingForCategoryFromJSON,
    RatingForCategoryFromJSONTyped,
    RatingForCategoryToJSON,
    RatingForCategoryToJSONTyped,
} from './RatingForCategory';
import type { Coordinates } from './Coordinates';
import {
    CoordinatesFromJSON,
    CoordinatesFromJSONTyped,
    CoordinatesToJSON,
    CoordinatesToJSONTyped,
} from './Coordinates';
import type { HotelPropertyContentAddress } from './HotelPropertyContentAddress';
import {
    HotelPropertyContentAddressFromJSON,
    HotelPropertyContentAddressFromJSONTyped,
    HotelPropertyContentAddressToJSON,
    HotelPropertyContentAddressToJSONTyped,
} from './HotelPropertyContentAddress';
import type { HotelPropertyContentImage } from './HotelPropertyContentImage';
import {
    HotelPropertyContentImageFromJSON,
    HotelPropertyContentImageFromJSONTyped,
    HotelPropertyContentImageToJSON,
    HotelPropertyContentImageToJSONTyped,
} from './HotelPropertyContentImage';

/**
 * Rich stored hotel metadata. This contract intentionally contains no rates, rate IDs, or rate statuses.
 * @export
 * @interface HotelPropertyContentResponse
 */
export interface HotelPropertyContentResponse {
    /**
     * 
     * @type {number}
     * @memberof HotelPropertyContentResponse
     */
    hotelId: number;
    /**
     * 
     * @type {string}
     * @memberof HotelPropertyContentResponse
     */
    propertyName: string;
    /**
     * 
     * @type {string}
     * @memberof HotelPropertyContentResponse
     */
    chainName?: string;
    /**
     * 
     * @type {string}
     * @memberof HotelPropertyContentResponse
     */
    brandName?: string;
    /**
     * 
     * @type {string}
     * @memberof HotelPropertyContentResponse
     */
    propertyType?: string;
    /**
     * 
     * @type {string}
     * @memberof HotelPropertyContentResponse
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof HotelPropertyContentResponse
     */
    rating?: number;
    /**
     * 
     * @type {number}
     * @memberof HotelPropertyContentResponse
     */
    averageGuestRating?: number;
    /**
     * 
     * @type {number}
     * @memberof HotelPropertyContentResponse
     */
    reviewCount?: number;
    /**
     * 
     * @type {Array<RatingForCategory>}
     * @memberof HotelPropertyContentResponse
     */
    categoryRatings?: Array<RatingForCategory>;
    /**
     * 
     * @type {number}
     * @memberof HotelPropertyContentResponse
     */
    yearBuilt?: number;
    /**
     * 
     * @type {number}
     * @memberof HotelPropertyContentResponse
     */
    yearLastRenovated?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof HotelPropertyContentResponse
     */
    themes?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof HotelPropertyContentResponse
     */
    isAllInclusive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HotelPropertyContentResponse
     */
    isAdultsOnly?: boolean;
    /**
     * 
     * @type {HotelPropertyContentAddress}
     * @memberof HotelPropertyContentResponse
     */
    address?: HotelPropertyContentAddress;
    /**
     * 
     * @type {Coordinates}
     * @memberof HotelPropertyContentResponse
     */
    coordinates?: Coordinates;
    /**
     * 
     * @type {string}
     * @memberof HotelPropertyContentResponse
     */
    heroImage?: string;
    /**
     * 
     * @type {Array<HotelPropertyContentImage>}
     * @memberof HotelPropertyContentResponse
     */
    images: Array<HotelPropertyContentImage>;
    /**
     * 
     * @type {Array<string>}
     * @memberof HotelPropertyContentResponse
     */
    amenities: Array<string>;
    /**
     * 
     * @type {Array<HotelPropertyContentRoom>}
     * @memberof HotelPropertyContentResponse
     */
    rooms: Array<HotelPropertyContentRoom>;
    /**
     * 
     * @type {Array<HotelCuratedContent>}
     * @memberof HotelPropertyContentResponse
     */
    curatedContent: Array<HotelCuratedContent>;
    /**
     * 
     * @type {CheckinInstructions}
     * @memberof HotelPropertyContentResponse
     */
    checkinInstructions?: CheckinInstructions;
    /**
     * 
     * @type {CheckoutInstructions}
     * @memberof HotelPropertyContentResponse
     */
    checkoutInstructions?: CheckoutInstructions;
    /**
     * 
     * @type {Array<Policy>}
     * @memberof HotelPropertyContentResponse
     */
    policies: Array<Policy>;
    /**
     * 
     * @type {Array<PropertyFee>}
     * @memberof HotelPropertyContentResponse
     */
    propertyFees: Array<PropertyFee>;
}

/**
 * Check if a given object implements the HotelPropertyContentResponse interface.
 */
export function instanceOfHotelPropertyContentResponse(value: object): value is HotelPropertyContentResponse {
    if (!('hotelId' in value) || value['hotelId'] === undefined) return false;
    if (!('propertyName' in value) || value['propertyName'] === undefined) return false;
    if (!('images' in value) || value['images'] === undefined) return false;
    if (!('amenities' in value) || value['amenities'] === undefined) return false;
    if (!('rooms' in value) || value['rooms'] === undefined) return false;
    if (!('curatedContent' in value) || value['curatedContent'] === undefined) return false;
    if (!('policies' in value) || value['policies'] === undefined) return false;
    if (!('propertyFees' in value) || value['propertyFees'] === undefined) return false;
    return true;
}

export function HotelPropertyContentResponseFromJSON(json: any): HotelPropertyContentResponse {
    return HotelPropertyContentResponseFromJSONTyped(json, false);
}

export function HotelPropertyContentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): HotelPropertyContentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'hotelId': json['hotel_id'],
        'propertyName': json['property_name'],
        'chainName': json['chain_name'] == null ? undefined : json['chain_name'],
        'brandName': json['brand_name'] == null ? undefined : json['brand_name'],
        'propertyType': json['property_type'] == null ? undefined : json['property_type'],
        'description': json['description'] == null ? undefined : json['description'],
        'rating': json['rating'] == null ? undefined : json['rating'],
        'averageGuestRating': json['average_guest_rating'] == null ? undefined : json['average_guest_rating'],
        'reviewCount': json['review_count'] == null ? undefined : json['review_count'],
        'categoryRatings': json['category_ratings'] == null ? undefined : ((json['category_ratings'] as Array<any>).map(RatingForCategoryFromJSON)),
        'yearBuilt': json['year_built'] == null ? undefined : json['year_built'],
        'yearLastRenovated': json['year_last_renovated'] == null ? undefined : json['year_last_renovated'],
        'themes': json['themes'] == null ? undefined : json['themes'],
        'isAllInclusive': json['is_all_inclusive'] == null ? undefined : json['is_all_inclusive'],
        'isAdultsOnly': json['is_adults_only'] == null ? undefined : json['is_adults_only'],
        'address': json['address'] == null ? undefined : HotelPropertyContentAddressFromJSON(json['address']),
        'coordinates': json['coordinates'] == null ? undefined : CoordinatesFromJSON(json['coordinates']),
        'heroImage': json['hero_image'] == null ? undefined : json['hero_image'],
        'images': ((json['images'] as Array<any>).map(HotelPropertyContentImageFromJSON)),
        'amenities': json['amenities'],
        'rooms': ((json['rooms'] as Array<any>).map(HotelPropertyContentRoomFromJSON)),
        'curatedContent': ((json['curated_content'] as Array<any>).map(HotelCuratedContentFromJSON)),
        'checkinInstructions': json['checkin_instructions'] == null ? undefined : CheckinInstructionsFromJSON(json['checkin_instructions']),
        'checkoutInstructions': json['checkout_instructions'] == null ? undefined : CheckoutInstructionsFromJSON(json['checkout_instructions']),
        'policies': ((json['policies'] as Array<any>).map(PolicyFromJSON)),
        'propertyFees': ((json['property_fees'] as Array<any>).map(PropertyFeeFromJSON)),
    };
}

export function HotelPropertyContentResponseToJSON(json: any): HotelPropertyContentResponse {
    return HotelPropertyContentResponseToJSONTyped(json, false);
}

export function HotelPropertyContentResponseToJSONTyped(value?: HotelPropertyContentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hotel_id': value['hotelId'],
        'property_name': value['propertyName'],
        'chain_name': value['chainName'],
        'brand_name': value['brandName'],
        'property_type': value['propertyType'],
        'description': value['description'],
        'rating': value['rating'],
        'average_guest_rating': value['averageGuestRating'],
        'review_count': value['reviewCount'],
        'category_ratings': value['categoryRatings'] == null ? undefined : ((value['categoryRatings'] as Array<any>).map(RatingForCategoryToJSON)),
        'year_built': value['yearBuilt'],
        'year_last_renovated': value['yearLastRenovated'],
        'themes': value['themes'],
        'is_all_inclusive': value['isAllInclusive'],
        'is_adults_only': value['isAdultsOnly'],
        'address': HotelPropertyContentAddressToJSON(value['address']),
        'coordinates': CoordinatesToJSON(value['coordinates']),
        'hero_image': value['heroImage'],
        'images': ((value['images'] as Array<any>).map(HotelPropertyContentImageToJSON)),
        'amenities': value['amenities'],
        'rooms': ((value['rooms'] as Array<any>).map(HotelPropertyContentRoomToJSON)),
        'curated_content': ((value['curatedContent'] as Array<any>).map(HotelCuratedContentToJSON)),
        'checkin_instructions': CheckinInstructionsToJSON(value['checkinInstructions']),
        'checkout_instructions': CheckoutInstructionsToJSON(value['checkoutInstructions']),
        'policies': ((value['policies'] as Array<any>).map(PolicyToJSON)),
        'property_fees': ((value['propertyFees'] as Array<any>).map(PropertyFeeToJSON)),
    };
}

